var render, staticRenderFns
import script from "./LinkMenu.vue?vue&type=script&lang=js&"
export * from "./LinkMenu.vue?vue&type=script&lang=js&"
import style0 from "./LinkMenu.vue?vue&type=style&index=0&id=73abf504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73abf504",
  null
  
)

export default component.exports